import { Injectable } from '@angular/core';

declare var partner: any;
declare var comcode: any;

@Injectable({
	providedIn: 'root'
})
export class EnvService {
	API_URL = 'http://api.logipro.kr/';
	PARTNER_CONF = partner;
	COM_CODE = comcode;
	constructor() { }
}
